import { render, staticRenderFns } from "./datepicker.vue?vue&type=template&id=220f81c4&"
import script from "./datepicker.vue?vue&type=script&lang=js&"
export * from "./datepicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports